<app-closeable-dialog-title
  [allowMaximize]="false"
  title="New Project">
</app-closeable-dialog-title>
<div mat-dialog-content class="dialog--content">
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-form-field class="full-width">
      <mat-label>Project Name</mat-label>
      <input matInput formControlName="name"/>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Topic</mat-label>
      <textarea matInput formControlName="topic"></textarea>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button class="save-btn" [disabled]="form.invalid" (click)="save()">
    <mat-icon>add</mat-icon>
    <span>Save</span>
  </button>
</div>
